import { render, staticRenderFns } from "./page.vue?vue&type=template&id=6092b5be&"
import script from "./page.vue?vue&type=script&lang=ts&"
export * from "./page.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/aef.slmndr.be/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6092b5be')) {
      api.createRecord('6092b5be', component.options)
    } else {
      api.reload('6092b5be', component.options)
    }
    module.hot.accept("./page.vue?vue&type=template&id=6092b5be&", function () {
      api.rerender('6092b5be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/blog/page.vue"
export default component.exports